/**
 * Mobile/Desktop Menu Category Switcher
 */
document.addEventListener('DOMContentLoaded', () => {
    const switchers = document.querySelectorAll('.category-switcher');
    if (switchers.length === 0) return;

    const panels = document.querySelectorAll('[data-category-panel]');

    // Initialize from localStorage or default to 1
    const activeTab = localStorage.getItem('activeCategoryTab') || '1';
    setActiveTab(activeTab);

    switchers.forEach(switcher => {
        const buttons = switcher.querySelectorAll('[data-category-tab]');
        buttons.forEach(button => {
            button.addEventListener('click', () => {
                const tabId = button.dataset.categoryTab;
                setActiveTab(tabId);
                localStorage.setItem('activeCategoryTab', tabId);
            });
        });
    });

    function setActiveTab(tabId) {
        document.querySelectorAll('[data-category-tab]').forEach(btn => {
            if (btn.dataset.categoryTab === tabId) {
                btn.classList.add('is-active');
            } else {
                btn.classList.remove('is-active');
            }
        });

        panels.forEach(panel => {
            if (panel.dataset.categoryPanel === tabId) {
                panel.classList.remove('is-hidden');
            } else {
                panel.classList.add('is-hidden');
            }
        });
    }
});
